import React, { useEffect, useState } from "react";
import SVGraphics from "../../assets/SVGraphics";
import { SelectInput } from "../input/SelectInput";
import { MultiSelect } from "../input/MultiSelect";
import { DateTimeInput } from "../input/DateTimeInput";
import CustomDropdown from "../input/CustomDropdown";
import { getInputAdornmentUtilityClass, Menu } from "@mui/material";
import { SlideInput } from "../../components/input/SlideInput";

const FiltersSideBar = (props) => {
  const [entry, setEntry] = useState({});
  const { isSideBarOpen } = props;

  useEffect(() => {}, []);

  const closeSideBar = async () => {
    document.body.style.overflow = "auto";
    props.closeSideBar(false);
  };

  const getInputByType = (input) => {
    if (input.type === "dropdown") {
      return (
        <CustomDropdown
          key={input.name}
          name={input.name}
          label={input.label}
          containerClassName={"w-fit"}
          inputClassName={
            "w-fit flex h-auto text-[13px] bg-transparent text-white"
          }
          onChange={(eventOrValue, maybeValue) => {
            const newValue =
              maybeValue !== undefined
                ? maybeValue
                : eventOrValue?.target?.value ?? eventOrValue;
            props.onFilterChange(input.name, newValue);
          }}
          data={input.data}
          maxHeight={"3rem"}
          value={props.filtersObj[input.name]}
          placeholder={input.label}
        />
      );
    } else if (input.type === "switch") {
      return (
        <SlideInput
          name={input.name}
          value={props.filtersObj[input.name]}
          onChange={(eventOrValue, maybeValue) => {
            const newValue =
              maybeValue !== undefined
                ? maybeValue
                : eventOrValue?.target?.value ?? eventOrValue;
            props.onFilterChange(input.name, newValue);
          }}
          step={1}
          rightLabel={input.label}
          marginTop="mt-0"
          min={0}
          max={1}
        />
      );
    }
  };

  const filtersCategory = props.filtersCategory ? props.filtersCategory : [];

  return (
    <div className={"flex"} style={{ width: isSideBarOpen ? "100%" : "0px" }}>
      <div className={" h-fit bg-transparent flex w-fit "}>
        {/* <SVGraphics onClick={() => closeSideBar()} className={'w-[1.5rem] h-[1.5rem] cursor-pointer'}
                            svgname={'close'}/> */}

        <div>
          {filtersCategory.map((item) => {
            return (
              <div>
                {/* <label className={"font-Poppins text-[#52007E] text-capitalize font-bold text-lg leading-7"}> {item.label} </label> */}
                <div
                  className={
                    "flex" +
                    props.gridStyle +
                    " gap-[27px] width-fit items-center"
                  }>
                  {item.inputs.map((input) => {
                    return getInputByType(input);
                  })}
                </div>
              </div>
            );
          })}

          {/* <div className={'w-full flex mt-[2rem]'}>
                        <div
                            className={"mt-[0.75rem] mr-[2.75rem] cursor-pointer text-right leading-trim tracking-tight text-capitalize font-Poppins text-[#52007E] text-opacity-100 text-lg font-normal underline"}
                            onClick={() => props.clearFilters()}
                        >
                            Clear All
                        </div>

                        <div
                            onClick={() => props.onApplyClick()}
                            className={"cursor-pointer w-[14rem] h-[3rem] py-[0.75rem] px-[1.5rem] text-center text-lg font-bold font-Poppins  gap-3 flex-shrink-0 rounded-full bg-[#52007E] shadow-black ml-auto " +
                                "text-[#FFF]"}>
                            Apply
                        </div>
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default FiltersSideBar;
